<template lang="pug">
.wagtail-color-richtext-overlay(:style="background")
  .wagtail-color-richtext-overlay__text(v-html="value.text")
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    background: function () {
      return {
        '--bg-color': this.value.color
      }
    }
  }
}
</script>

<style lang="scss">
.wagtail-color-richtext-overlay {
  width: 100%;
  padding: 100px 0;
  position: relative;

  &:before {
    content: "";
    // width: 99.45vw;
    height: 100%;
    background-color: var(--bg-color);
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -50vw;
    z-index: 1;
  }

  &__text {
    position: relative;
    z-index: 22;
    width: 100%;
    color: $dark;
    padding: 90px 0;

    h2 {
      color: $primary;
      margin-bottom: 40px;
      font-weight: bold;
    }

    p,
    ul,
    ol {
      margin-bottom: 30px;
    }

    li {
      margin-bottom: 30px;

      :last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
